// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"208":"a0d87559","479":"99e7c55a","515":"f026582c","558":"380f7218","714":"46524555","802":"06d0da32","803":"cc71013e","809":"7116409f","874":"ee683a49"}[chunkId] + ".js";
};